export enum MenuItemTag {
  a = 'a',
  aBlank = 'aBlank',
  div = 'div',
}
